
import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MockData } from '../mock/mock';
import { catchError } from 'rxjs/operators'
import { NotificationService } from './notifications.service';
import { NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable(
    { providedIn: 'root' }
)
export class BaseHttpService {

    mockData: MockData = new MockData();
    /**
     * Constructor
     * @param http
     */
    constructor(private injector: Injector, private http: HttpClient, private notificationService: NotificationService, private zone: NgZone) {


    }
    /**
     * Use this method to process all API GET calls
     * @param url
     */
    get(url: string, options?): Observable<any> {
        if (environment.useMockData) {
            return this.mockData.getMock(url);
        }
        else {
            return this.http.get<any>(url, options).pipe(
                 catchError(this.handleError)
            );
        }
    };
    /**
     * Use this method to process all API GET by ID calls
     * @param url
     * @param id
     */
    getById(url: string, id: string, options?): Observable<any> {

        if (environment.useMockData) {
            return this.mockData.getMock(url).pipe(
                //  catchError(this.handleError)
            );
        }
        else {
            return this.http.get<any>(url + '/' + id, options).pipe(
                catchError(this.handleError)
           );
        }
    };

    getByIdValue(url: string, id: string, value: string[]): Observable<any> {

        if (environment.useMockData) {
            return this.mockData.getMock(url).pipe(
                //  catchError(this.handleError)
            );
        }
        else {
            return this.http.get<any>(url + '/' + id + '/' + value).pipe(
                catchError(this.handleError)
           );
        }
    };

    /**
     * Use this method to process all API PUT calls
     * @param url
     * @param payload
     */
    put(url: string, payload: any) {

        if (environment.useMockData) {
            return this.mockData.getMock(url).pipe(
                //  catchError(this.handleError)
            );
        }
        else {
            return this.http.put(url, payload).pipe(
                catchError(this.handleError)
           );
        }
    };
    /**
     * Use this method to process all API POST calls
     * @param url
     * @param payload
     */
    post(url: string, payload: any, options?) {

        if (environment.useMockData) {
            return this.mockData.getMock(url);
        }
        else {
            return this.http.post(url, payload, options).pipe(
                catchError(this.handleError)
            );
        }
    };
    delete(url: string, payload: any) {//debugger
        if (environment.useMockData) {
            return this.mockData.getMock(url);
        }
        else {
            return this.http.delete(url + "/" + payload).pipe(
                catchError(this.handleError)
            );
        }
    };

    deleteApi(url: string) {
        //debugger
        if (environment.useMockData) {
            return this.mockData.getMock(url);
        }
        else {
            return this.http.delete(url).pipe(
                catchError(this.handleError)
            );
        }
    };

      handleError(error: HttpErrorResponse) {
          //console.log('Is it firing here');
          // this.toastrService.error("We were unable to complete your request. Please try again in sometime if the error persists", null, { onActivateTick: true });
           // this.notificationService.showError("We were unable to complete your request. Please try again in sometime if the error persists", "Error");
            return throwError(error);
        }

    /**
* Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
* @returns {} 
*/
    private get toastrService(): ToastrService {
        return this.injector.get(ToastrService);
    }
}